import { isDefined } from "@clipboard-health/util-ts";
import { Stack } from "@mui/material";
import { type ReactNode } from "react";

import { Text } from "./Text";

export interface SettingsSectionProps {
  title: string;
  children: ReactNode;
  description?: ReactNode;
  hideHeader?: boolean;
}

export function SettingsSection({
  title,
  children,
  description,
  hideHeader = false,
}: SettingsSectionProps) {
  return (
    <Stack
      spacing={3}
      sx={(theme) => ({
        padding: theme.spacing(3, 4),
        borderRadius: theme.borderRadius?.large,
        backgroundColor: theme.palette.background?.paper,
        border: `1px solid ${String(theme.palette.divider)}`,
      })}
    >
      {!hideHeader && (
        <Stack spacing={1}>
          <Text semibold variant="body1">
            {title}
          </Text>
          {isDefined(description) && (
            <Text variant="body2" sx={(theme) => ({ color: theme.palette.text.secondary })}>
              {description}
            </Text>
          )}
        </Stack>
      )}
      <Stack
        spacing={0}
        sx={(theme) => ({
          "& > *:not(:last-child)": { borderBottom: `1px solid ${String(theme.palette.divider)}` },
        })}
      >
        {children}
      </Stack>
    </Stack>
  );
}
